import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { AvatarUpload } from '@welldev-group/react-comp-lib';
import classNames from 'classnames';
import Modal from '@welldev-group/rcl-modal';
import Button from '@welldev-group/rcl-button';
import Icon from '@welldev-group/rcl-icon';
import IconButton from '@welldev-group/rcl-icon-button';

import './styles.scss';

const UploadImage = props => {
  const {
    className,
    updateAvatar,
    circularCrop,
    minWidth,
    minHeight,
    title,
    previousImageName,
  } = props;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [imageName, setImageName] = useState(null);

  const onModalOpen = () => setIsModalVisible(true);
  const onModalClose = () => setIsModalVisible(false);

  const onAvatarSave = (image, crop) => {
    const file = new File([image], image.name, { type: image.type });
    updateAvatar(file, crop);
    onModalClose();
    setImageName(image.name);
  };

  return (
    <Fragment>
      {circularCrop ? (
        <IconButton
          version="v2"
          isIconOnly={true}
          icon={<Icon name="cameraAlt" color="tertiary" showBGColor={true} />}
          size="small"
          onClick={onModalOpen}
        />
      ) : (
        <div className="avatar-modal__upload-button">
          <Button
            label={I18n.t('admin.shared.action.choose_file')}
            size="small"
            version="v2"
            onClick={onModalOpen}
          />
          <span>
            {imageName ||
              previousImageName ||
              I18n.t('admin.components.products.attribute.no_chosen')}
          </span>
        </div>
      )}

      <Modal
        isVisible={isModalVisible}
        onOutsideClick={onModalClose}
        className={classNames('avatar-modal', className)}
      >
        {/* <Modal.Content> */}
        {
          // TODO: We will have to pass a prop to Avatar Upload to use rectangular cropping for organization edit
        }
        <AvatarUpload
          onAvatarUpload={onAvatarSave}
          title={title}
          onClose={onModalClose}
          circularCrop={circularCrop}
          minWidth={minWidth}
          minHeight={minHeight}
        />
        {/* </Modal.Content> */}
      </Modal>
    </Fragment>
  );
};

UploadImage.defaultProps = {
  className: null,
  circularCrop: true,
  minWidth: 70,
  minHeight: 70,
  previousImageName: null,
};

UploadImage.propTypes = {
  className: PropTypes.string,
  updateAvatar: PropTypes.func.isRequired,
  circularCrop: PropTypes.bool,
  minWidth: PropTypes.number,
  minHeight: PropTypes.number,
  title: PropTypes.string.isRequired,
  previousImageName: PropTypes.string,
};

export default UploadImage;
